export default [
	{
		path: "/pros/referrals",
		exact: true,
		policy: "providerAuth",
		component: "Referrals",
		mui: true,
	},
];
